export default "__VITE_ASSET__ChHtuHqU__"